import { Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Loading from "../../components/Loading/Loading";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import TableRoles from "./TableRoles/TableRoles";
import toast from "react-hot-toast";
import { handleError } from "../../utils/handleError";
import { useDispatch, useSelector } from "react-redux";
import { setListRoles } from "../../redux/slice/roles";
import RoleModal from "./ModalRole";
import { getAllRolesAPI } from "../../services/roles/roleService";
import ModalAlertOfRole from "./ModalAlertOfRole";

const Roles = () => {
  const [loading, setLoading] = useState(true);
  const [showModalRole, setShowModalRole] = useState(false);
  const [showModalAlert, setShowModalAlert] = useState(false);
  const { listRoles } = useSelector((state) => state.rolesReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    const getAllRoles = async () => {
      try {
        const listRoles = await getAllRolesAPI();
        // console.log("Lista de roles", listRoles);
        dispatch(setListRoles({ listRoles: listRoles }));
        setLoading(false);
      } catch (error) {
        const { message } = handleError(error);
        setLoading(false);
        toast.error(`No se pudieron obtener los roles. \n ${message}`);
      }
    };
    getAllRoles();
    setShowModalAlert(true);
  }, [dispatch]);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <ModalAlertOfRole open={showModalAlert} setOpen={setShowModalAlert} />
      <RoleModal
        open={showModalRole}
        setOpen={setShowModalRole}
        setLoading={setLoading}
      />
      <Loading loading={loading} />
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 4,
        }}
      >
        <Typography variant="h5">Roles</Typography>
        <Button
          variant="contained"
          sx={{ backgroundColor: "#e7ef7d" }}
          startIcon={<PersonAddIcon />}
          onClick={() => {
            setShowModalRole(true);
          }}
        >
          Agregar rol
        </Button>
      </Box>
      <TableRoles setLoading={setLoading} rows={listRoles ?? []} />
    </Box>
  );
};

export default Roles;
